module.exports = __webpack_public_path__ + "static/media/07.510c1fc0.png";